<template>
  <el-select v-model="value">
    <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.name"></el-option>
  </el-select>
</template>

<script>
const politics = [
  {
    name : '群众'
  },
  {
    name : '中共党员'
  },
  {
    name : '中共预备党员'
  },
  {
    name : '共青团员'
  },
  {
    name : '民革会员'
  },
  {
    name : '民盟盟员'
  },
  {
    name : '民建会员'
  },
  {
    name : '民进会员'
  },
  {
    name : '民工党党员'
  },
  {
    name : '致公党党员'
  },
  {
    name : '九三学社社员'
  },
  {
    name : '台盟盟员'
  },
  {
    name : '无党派人士'
  }
]
export default {
  name: 'PoliticalStatus',
  data() {
    return {
      options: politics,
      value: ''
    }
  }
}
</script>

<style>

</style>